/* -------------------------------------------------------------------------- */
/* HYBRID MIXIN                                                               */
/* -------------------------------------------------------------------------- */
import {
    Component, Mixins, Prop,
} from 'vue-property-decorator';
import { snakeToCamel } from '@groot-nodes/helpers/string';

/**
 * Hybrid Mixin
 */
@Component
class HybridMixin extends Mixins() {
    /**
     * Props passed by backend
     */
    @Prop() elements!: object;

    /**
     * Get the value of the prop
     * 
     * @param {string} prop
     * @param {string | number | null} defaultValue
     * @returns {any}
     */
    getValue(prop: string, defaultValue: string | boolean | null = null): any {
        if (!prop) {
            return false;
        }
        if (this.elements && this.elements[prop]) {
            return [null, undefined].includes(this.elements[prop]) ? defaultValue : this.elements[prop];
        }
        return [null, undefined].includes(this[snakeToCamel(prop)]) ? defaultValue : this[snakeToCamel(prop)];
    }

    /**
     * Get the value of the object property
     *
     * @param {string} prop
     * @param {string} property
     * @param {any} defaultValue
     * @returns {any}
     */
    getObject(prop: string, property: string, defaultValue: any = null): any {
        if (!prop) {
            return false;
        }
        if (this.elements && this.elements[prop]) {
            return this.elements[prop][property] || defaultValue;
        }
        if (this[snakeToCamel(prop)]) {
            return this[snakeToCamel(prop)][snakeToCamel(property)] || defaultValue;
        }
        return defaultValue || null;
    }

    /**
     * Get value as boolean
     *
     * @param {string} prop
     * @param {boolean} defaultValue
     * @returns {boolean}
     */
    getBoolean(prop: string, defaultValue: boolean = false): boolean {
        return !!this.getValue(prop, defaultValue);
    }
}

export default HybridMixin;
